module.exports = __webpack_public_path__ + "img/handtap.cd83953f.png";